import { DataGrid } from "devextreme-react";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useDataSource } from "../../../contexts/dataSource";
import { useAuth } from "../../../contexts/auth";
import { getPropsDataGrid, getPropsDataGridEditing } from "../../../utils/default-props";
import { Column, Editing, Form, Lookup, Popup, Toolbar } from "devextreme-react/data-grid";
import { useScreenSize } from "../../../utils/media-query";
import { Item } from "devextreme-react/form";
import { getDataGridCustomToolbarCaption } from "../../../components/default-components/data-grid-custom-toolbar";
import { useLookupGroup } from "../../../contexts/lookup-group-context";
import { lookupGroups } from "../../../utils/lookup-groups.ts";


function Family({ employeeId }) {

    const [sizeParam, setSizeParam] = useState({})
    const { isXSmall, isLarge, isMedium } = useScreenSize();
    const { dataSourceHR } = useDataSource()
    const { user } = useAuth()
    const { getLookupData } = useLookupGroup()
    const [affinityList, setAffinityList] = useState(undefined)

    useEffect(() => {
        getLookupData(lookupGroups.affinity).then(response => {
            setAffinityList(response)
        })

    }, [])

    const dataSource = useMemo(() => dataSourceHR({
        loadUrl: `/api/EmployeeFamilyMember/Employee/${employeeId}`,
        insertUrl: "/api/EmployeeFamilyMember/FormData"
    }), [user, employeeId])

    const handleInitNewRow = useCallback((e) => {
        e.data.employeeId = employeeId
    }, [employeeId])


    useEffect(() => {
        if (isLarge || isMedium)
            setSizeParam({ width: 400, height: 400 })
        else
            setSizeParam({})
    }, [isLarge, isMedium])

    const affinityOption = {
        items: affinityList ,
        valueExpr: "id",
        displayExpr: "text"
    }

    return (
        <React.Fragment>
            <DataGrid
                dataSource={employeeId ? dataSource : undefined}
                //formData={formData}
                {...getPropsDataGrid}
                onInitNewRow={handleInitNewRow}
            >
                <Editing {...getPropsDataGridEditing}>
                    <Popup title="Kayıt İşlemi" showTitle={true} {...sizeParam} />
                    <Form >
                        <Item itemType="group" colSpan={2} >
                            <Item dataField="identityNumber" />
                            <Item dataField="name" />
                            <Item dataField="surname" />
                            <Item dataField="birthDate" />
                            <Item dataField="affinityId" editorType="dxSelectBox" editorOptions={affinityOption} />
                        </Item>
                    </Form>

                </Editing>
                <Toolbar>
                    {getDataGridCustomToolbarCaption("Aile Bilgileri")}
                    <Item name="addRowButton" location="after" />
                </Toolbar>
                <Column dataField="identityNumber" caption="Kimlik No" />
                <Column dataField="name" caption="Adı" />
                <Column dataField="surname" caption="Soyadı" />
                <Column dataField="birthDate" caption="Doğum Tarihi" dataType="date" />

                <Column dataField="affinityId" caption="Yakınlığı">
                    <Lookup dataSource={affinityList} valueExpr="id" displayExpr="text" />
                </Column>

            </DataGrid>
        </React.Fragment>
    )
}


export default React.memo(Family)